<div class="public-cv" style="direction: ltr !important;">
    <div class="container">
        @if(dataLoading) {
        <div class="dataLoading h-100 py-5">
            <div class="spinner-border"></div>
        </div>
        } @else {
        @if(isVerified && cvDetails && cvDetails.personal_details) {
        <div class="verify-card verified card">
            <div class="card-with-icon cv mt-4">
                <img src="/assets/images/icons/cv-verified-illustration.svg" alt="">
                <h3>This CV is authenticated and certified by Thrwty</h3>
                <p>You can match the information with the display below</p>
            </div>
        </div>
        <div class="cv-content mt-5">
            <div class="card mt-4">
                <div class="cv-template">
                    <div class="cv-header">
                        <div class="content">
                            <div class="img-card">
                                <img [src]="cvDetails.profile_picture" alt="">
                            </div>
                            <div class="name">
                                <h1>{{cvDetails.personal_details.first_name}}</h1>
                                <h2>{{cvDetails.personal_details.last_name}}</h2>

                                <p>{{cvDetails.personal_details.job_title}}</p>
                            </div>
                            <div class="certified">
                                Verified by
                                <img src="/assets/images/logo-colored.svg" alt="">
                            </div>
                        </div>
                    </div>

                    <div class="cv-content">
                        <div class="main-info">
                            <div class="info">
                                <div class="phoneNumber always-ltr width-max-content align-items-start">{{cvDetails.personal_details.phone_number}}</div>
                            </div>
                            <div class="info">
                                <div class="location">{{cvDetails.personal_details.city_name}}, {{cvDetails.personal_details.country_name}}</div>
                            </div>
                            <div class="info">
                                <div class="email">{{cvDetails.personal_details.email}}</div>
                            </div>
                            <div class="info">
                                <div class="birthdate"><span>{{(cvDetails.personal_details.birth_date | date: 'dd-MM-y') || ''}}</span></div>
                            </div>
                        </div>

                        <div class="card card-with-absolute-title">
                            <div class="title">
                                <img src="/assets/images/icons/about-me.svg" alt="">
                                About Me
                            </div>
                            <div class="card-content">
                                <p [innerHTML]="formattedCV(cvDetails.personal_details.about)"></p>
                            </div>
                        </div>

                        @if(isCompetencyCV) {
                        <!-- Competencies-->
                        <div class="card card-with-absolute-title">
                            <div class="title">
                                <img src="/assets/images/icons/Competencies-icon.png" alt="">
                                Competencies
                            </div>

                            <div class="card-content">
                                <div class="competencies">
                                    <div class="competence" *ngFor="let competence of cvDetails.competencies">
                                        <div class="competence-right">
                                            <div class="competence-name">
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <p>{{competence.name}}</p>

                                                    <div class="badge" [ngClass]="{
                                                            'green': (competence.value=='excellent'),
                                                            'light-green': (competence.value=='good_high'),
                                                            'yellow': (competence.value=='good'),
                                                            'red': (competence.value=='poor')}">{{'profile.'+
                                                        competence.value | translate}}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="progress">
                                                @if(competence.value=='excellent') {
                                                <app-progress-boxes [total]="10" [filled]="8" [filledColor]="'#38761D'"
                                                    [emptyColor]="'#D9EAD3'" [isBordered]="false"></app-progress-boxes>
                                                } @else if(competence.value=='good_high') {
                                                <app-progress-boxes [total]="10" [filled]="7" [filledColor]="'#9FCE63'"
                                                    [emptyColor]="'#ECF5E0'" [isBordered]="false"></app-progress-boxes>
                                                } @else if(competence.value=='good') {
                                                <app-progress-boxes [total]="10" [filled]="6" [filledColor]="'#FFC12A'"
                                                    [emptyColor]="'#FEF2D0'" [isBordered]="false"></app-progress-boxes>
                                                } @else if(competence.value=='poor') {
                                                <app-progress-boxes [total]="10" [filled]="2" [filledColor]="'#B62D23'"
                                                    [emptyColor]="'#F1D5D3'" [isBordered]="false"></app-progress-boxes>
                                                }
                                            </div>
                                        </div>
                                        <div class="competence-left">
                                            {{competence.work_style}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }

                        <div class="card card-with-absolute-title">
                            <div class="title">
                                <img src="/assets/images/icons/education-cv.svg" alt="">
                                Education
                            </div>
                            <div class="card-content">
                                <div class="list-content" *ngFor="let education of cvDetails.education">
                                    <div class="right d-flex align-items-center">
                                        <div class="icon-card">
                                            <img src="/assets/images/icons/university-icon.svg" alt="">
                                        </div>
                                        <div class="details">
                                            <h2>{{education?.institute_name}}</h2>
                                            <h4>{{education?.degree_name + ' |'}} {{education?.major}}</h4>
                                            <p *ngIf="education.grade">Grade: <span>{{education?.grade}}
                                                @if (education.scale?.type == 'four' || education.scale?.type == 'five') {
                                                    {{education.scale?.name}}
                                                  } @else if(education.scale?.type == 'percentage') {
                                                    %
                                                  }
                                            </span></p>
                                        </div>
                                    </div>
                                    <div class="left">
                                        <div class="date color-gray2 mb-2">
                                            {{(education?.from_month+'/'+'1/'+education?.from_year | date:'MMMM y') ||
                                            ''}}
                                            -
                                            @if (education.until_now) {
                                            Until Now
                                            } @else {
                                            {{(education?.to_month+'/'+'1/'+education?.to_year | date:'MMMM y') || ''}}
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        @if(!isCompetencyCV) {
                        <div class="card card-with-absolute-title">
                            <div class="title">
                                <img src="/assets/images/icons/work-experience-icon.svg" alt="">
                                Work Experience
                            </div>
                            <div class="card-content">
                                <div class="list-content" *ngFor="let workExp of cvDetails.WorkExperience">
                                    <div class="right d-flex align-items-center">
                                        <div class="icon-card">
                                            <img src="/assets/images/icons/company-icon.svg" alt="">
                                        </div>
                                        <div class="details">
                                            <h2 [ngClass]="{'mb-0': !workExp.description}">{{workExp?.job_title}}
                                                ({{workExp?.employment_type_name}})</h2>
                                            <h4>{{workExp?.company_name}} - {{workExp?.city_name}}</h4>
                                            <h4 class="w-75 mt-2 font-12"
                                                [innerHTML]="formattedCV(workExp.description)"></h4>
                                        </div>
                                    </div>
                                    <div class="left">
                                        <div class="date color-gray2 mb-2">
                                            {{(workExp?.from_month+'/'+'1/'+workExp?.from_year | date:'MMMM y') || ''}}
                                            -
                                            @if (workExp.until_now) {
                                            Until Now
                                            } @else {
                                            {{(workExp?.to_month+'/'+'1/'+workExp?.to_year | date:'MMMM y') || ''}}
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card card-with-absolute-title" *ngIf="cvDetails.certificates.length">
                            <div class="title">
                                <img src="/assets/images/icons/certifications-icon-cv.svg" alt="">
                                Certificates and licenses
                            </div>
                            <div class="card-content">
                                <div class="list-content" *ngFor="let certificate of cvDetails.certificates">
                                    <div class="right d-flex align-items-center">
                                        <div class="icon-card">
                                            <img src="/assets/images/icons/certifications-icon-grey.svg" alt="">
                                        </div>
                                        <div class="details">
                                            <h2>{{certificate?.certificate_name}}</h2>
                                            <h4>{{certificate?.issuing_organization}}</h4>
                                        </div>
                                    </div>
                                    <div class="left">
                                        <div class="date color-gray2 mb-2">
                                            {{(certificate?.issue_month+'/'+'1/'+certificate?.issue_year | date:'MMMM y') || ''}}
                                            -
                                            @if (certificate.does_not_expire) {
                                            No expiration date
                                            } @else {
                                            {{(certificate?.expiration_month+'/'+'1/'+certificate?.expiration_year |
                                            date:'MMMM y') || ''}}
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }

                        <div class="card card-with-absolute-title">
                            <div class="title">
                                <img src="/assets/images/icons/pencil-cv.svg" alt="">
                                Skills
                            </div>
                            <div class="card-content">
                                <div class="list-content" *ngFor="let skill of cvDetails.skills">
                                    <div class="right d-flex align-items-center">
                                        <div class="icon-card">
                                            <img src="/assets/images/icons/pencil-grey.svg" alt="">
                                        </div>
                                        <div class="details">
                                            <h2 [ngClass]="{'mb-0': !skill.description}">{{skill?.title}}</h2>
                                            <h4 [innerHTML]="formattedCV(skill.description)"></h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        } @else {
        <div class="verify-card not-verified card">
            <div class="card-with-icon cv mt-4">
                <img src="/assets/images/icons/cv-not-verified-illustration.svg" alt="">
                <h3>This CV is not authenticated by Thrwty</h3>
            </div>
        </div>
        }
        }
    </div>
</div>